import script from "./NewReleaseList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewReleaseList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__